import { PageHeader, Form, Row, Col, Input, Select, Button, message, Modal } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { UsergroupAddOutlined } from '@ant-design/icons';
import { useReactToPrint } from "react-to-print"
import { useParams } from 'react-router-dom';
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import { Items } from "../../services/items";
import moment from "moment";
import apis from "../../services/apis";
import InvoiceItems from '../../components/invoice/InvoiceItems'
import InvoicePrint from '../../components/invoice/InvoicePrint'
import confirm from 'antd/lib/modal/confirm';
import { Link} from "react-router-dom";


export default function EditInvoice() {
  const {
    projects,
    invoicedispatch,
    invoicesinge,
    projectdispatch,
    businessdispatch,
    businesses,
    items,
    invoiceItemdispatch
  } = useApiContext();
  const { id } = useParams();
  const [loading, setLoading] = useState(false)
  const [invoiceForm] = Form.useForm()
  const [projectData, setProjectData] = useState();
  const [busineesData, setBusineesData] = useState();
  const [businees, setBusinees] = useState();
  const [projectId, setProjectId] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [invoiceId, setInvoiceId] = useState("")
  const [invoiceDate, setInvoiceDate] = useState("")
  const [productVat, setproductVat] = useState("")
  const [customField1, setCustomField1] = useState("")
  const [customField2, setCustomField2] = useState("")
  const [customField3, setCustomField3] = useState("")
  const [customField4, setCustomField4] = useState("")
  const [customField5, setCustomField5] = useState("")
  const [customField6, setCustomField6] = useState("")
  const [invoiceData, setInvoiceData] = useState({})
  const [isopen, setIsopen] = useState(false);
  const [enablePrinting, setEnablePrinting] = useState(false)
  const [isSaved, setIsSaved] = useState(true);
  const [stampType, setStampType] = useState("")

  let printRef = useRef();

  useEffect(() => {
    if (projects.length < 1) {
      apis.Projects.list(projectdispatch);
    }
    if (businesses.length < 1) {
      const data = apis.Businesses.list(businessdispatch);
      setBusineesData(data);
    }

    if (id) {
      Items.remove(invoiceItemdispatch, [])
      apis.Invoices.get(invoicedispatch, id).then(res => {
        setInvoiceData(res.data)
        setInvoiceId(res.data.id)
        res.data.invoiceItems.map(item => {
          let newvalue = {
            id: item.id,
            description: item.description,
            price: item.price,
            quantity: item.quantity,
            amount: item.price * item.quantity
          }
          Items.add(invoiceItemdispatch, newvalue)
        })
        setInvoiceNo(res.data.invoiceNumber)
        setCustomField1(res.data.customField1)
        setCustomField2(res.data.customField2)
        setCustomField3(res.data.customField3)
        setCustomField4(res.data.customField4)
        setCustomField5(res.data.customField5)
        setCustomField6(res.data.customField6)
        setProjectData(res.data.project)
        setproductVat(res.data.project.vatNumber)
        setBusinees(res.data.business)
        setStartDate(res.data.startDate)
        setEndDate(res.data.endDate)
        setInvoiceDate(res.data.invoiceDate)
        invoiceForm.setFieldsValue({
          projectId: res.data.projectId,
          businessId: res.data.businessId,
          invoiceDate: moment(res.data.invoiceDate).format('YYYY-MM-DD'),
          startDate: moment(res.data.startDate).format("YYYY-MM-DD"),
          endDate: moment(res.data.endDate).format('YYYY-MM-DD'),
          projectVat: res.data.project.vatNumber,
          companyName: res.data.customField4

        })
        console.log("from useeffect", res.data);
      })
      // Items.add(invoiceItemdispatch, invoicesinge.invoiceItems)
    }



  }, [id])
  const getProjectData = (value) => {
    setproductVat("")
    invoiceForm.setFieldsValue({ "projectVat": "" })
    const data = projects.find((x) => x.id == value);
    setProjectData(data);
    setProjectId(data.id);
    if (data.vatNumber) {
      invoiceForm.setFieldsValue({ "projectVat": data.vatNumber })
      setproductVat(data.vatNumber)
    }
    console.log("Project data", data);
  };



  const getBusinessData = (value) => {
    const data = businesses.find((x) => x.id == value);
    setBusinees(data);
    console.log("Business Data", data);
  };
  const onFinish = (values) => {
    setLoading(true)
    let newValues = {
      ...values, id: invoiceId, invoiceItems: items, invoiceNumber: invoiceNo, customField1: customField1,
      customField2: customField2, customField3: customField3, customField4: customField4, customField5: customField5,
      customField6: customField6,
      invoiceAmount: Number(((items.reduce((a, b) => a + b.amount, 0) + items.reduce((a, b) => a + b.amount, 0) * 0.15).toFixed(2))),
      vatAmount: Number((items.reduce((a, b) => a + b.amount, 0) * 0.15).toFixed(2))
    }
    apis.Invoices.edit(invoicedispatch, newValues).then(res => {
      setLoading(false)
      invoiceForm.resetFields()
      message.success("Invoice Added Successfully")
      setEnablePrinting(true)
      setIsSaved(false)
    })
    console.log("invoice values", newValues);
  }
  const onFinishFailed = (error) => {

  }

  const setStampOne = (values) => {
    if(values.PIN == "@admin225"){
      setStampType('1')
      message.success("Stamp one is applied on invoice")
    }else if(values.PIN == "@admin478"){
      setStampType('2')
      message.success("Stamp two is applied on invoice")
    }else {
      message.error("Wrong stamp code")
    }
  }

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
     
      Items.remove(invoiceItemdispatch, [])
      setCustomField1("")
      setCustomField2("")
      setCustomField3("")
      setCustomField4("")
      setCustomField5("")
      // setCustomField6("")  
      invoiceForm.resetFields()
      setEnablePrinting(false)
      setIsSaved(true)
      window.location.reload();

    },

  })
  return (
    <div style={{ position: 'relative', marginBottom: '40px' }}>
      <Link to={`/invoiceList`}>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Edit Invoice"
        subTitle="Enter below details to Edit invoice"
      />
      </Link>
      




      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="basic"
        form={invoiceForm}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="gx-signin-form"
      >
        <Row style={{ marginTop: '20px' }}>
          <Col span={12}>
            <Form.Item
              label="Select Project"
              name="projectId"
              rules={[{ required: true, message: 'Please select project' }]}

            >
              <Select placeholder="Select project" onChange={getProjectData}>
                {projects.map(item => (
                  <Select.Option value={item.id}>{item.projectName}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Project VAT"
              name="projectVat"

              rules={[{ required: true, message: 'Please enter project vat' }]}
            >
              <Input placeholder='Project VAT Number' onChange={(e) => setproductVat(e.target.value)} />
            </Form.Item>
            <Form.Item
              label="Select Business"
              name="businessId"
              rules={[{ required: true, message: 'Please select business' }]}

            >
              <Select placeholder="Select Business" onChange={getBusinessData}>
                {businesses.map(item => (
                  <Select.Option value={item.id}>{item.businessName}</Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Invoice Number"
              name="invoiceNumber"
              initialValue={invoiceNo}
            >
              <label>{invoiceNo}</label>
            </Form.Item>
            <Input.Group compact style={{ paddingBottom: '10px' }}>
              <Input name='customField1' value={customField1} onChange={(e) => setCustomField1(e.target.value)} style={{ width: '25%', marginLeft: '25px' }} placeholder="Contact Label" />
              <Input name='customField2' value={customField2} onChange={(e) => setCustomField2(e.target.value)} style={{ width: '60%' }} placeholder="Contact details" />
            </Input.Group>

          </Col>
          <Col span={12}>

          <Form.Item
              label="Company Name"
              name="companyName"
              // rules={[{ required: true, message: 'Please enter project vat' }]}
            >
              <Input placeholder='Contact details' onChange={(e) => setCustomField3(e.target.value)} />
            </Form.Item>
            <Input.Group compact style={{ paddingBottom: '10px' }}>
              <Input name='customField5' value={customField5} onChange={(e) => setCustomField5(e.target.value)} style={{ width: '30%', marginLeft: '25px' }} placeholder="Contact Label" />
              <Input name='customField6' value={customField6} onChange={(e) => setCustomField6(e.target.value)} style={{ width: '60%' }} placeholder="Contact details" />
            </Input.Group>
            <Form.Item
              label="Invoice Date"
              name="invoiceDate"
              rules={[{ required: true, message: 'Please select invoice date' }]}
            >
              <Input type="date" onChange={(e) => setInvoiceDate(e.target.value)} />
            </Form.Item>
            <Form.Item
              label="Invoice Start date"
              name="startDate"

              rules={[{ required: true, message: 'Please select invoice date' }]}
            >
              <Input type="date" onChange={(e) => setStartDate(e.target.value)} />
            </Form.Item>
            <Form.Item
              label="Invoice End Date"
              name="endDate"

              rules={[{ required: true, message: 'Please select invoice date' }]}
            >
              <Input type="date" onChange={(e) => setEndDate(e.target.value)} />
            </Form.Item>
          </Col>
        </Row>


        <div style={{ position: 'absolute', bottom: '-45px', left: '0px' }}>
          {isSaved &&

            <Button loading={loading} type="primary" htmlType="submit" icon={<UsergroupAddOutlined />} style={{ marginRight: '5px' }}>
              Update Invoice
            </Button>
          }
          {
            enablePrinting &&
            <Button onClick={handlePrint} type='primary' style={{ marginRight: '5px' }}>Print Invoice</Button>
          }
          {
            enablePrinting &&
            <Button
              type="primary"
              style={{ marginRight: '5px' }}
              onClick={() => setIsopen(true)}

            >
              Stamp
            </Button>
          }
        </div>
        <InvoiceItems
          saved={isSaved}
        />
        {/* Print template component */}
        <div style={{ display: 'none' }}>

          <InvoicePrint
            ref={printRef}
            invoiceNo={invoiceNo}
            startDate={startDate}
            endDate={endDate}
            invoiceDate={invoiceDate}
            projectData={projectData}
            businees={businees}
            projectVat={productVat}
            customField1={customField1}
            customField2={customField2}
            customField3={customField3}
            customField4={customField4}
            customField5={customField5}
            customField6={customField6}
            stampImage={stampType}
            editInvoice={true}
          />
          
        </div>

      </Form>
      <Modal
        visible={isopen}
        title="Please Input 4 Digit PIN"
        footer={null}
        onCancel={() => setIsopen(false)}
        width={350}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 20 }}
          name="basic"
          onFinish={setStampOne}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
          <Row>
            <Form.Item
              label="PIN"
              name="PIN"
              rules={[{ type: "PIN" }, { min: 5, warningOnly: true }]}
              hasFeedback
            >
              <Input type="password" />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    </div>


  )
}
